export function PlanToWatch() {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="235"
        height="69"
        viewBox="0 0 235 69"
        fill="none"
      >
        <g filter="url(#filter0_d_1664_7988)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 15.9809C4.23152 16.0572 4.46339 16.1373 4.69544 16.2218C6.15431 16.7493 8.132 17.7274 8.76454 18.8818C8.18315 16.6072 7.09671 14.6714 4.98637 13.1223C6.42498 14.1118 8.31002 14.8064 10.2077 15.5057L10.2077 15.5057C12.8128 16.4656 15.4416 17.4342 16.9724 19.1866C17.5576 19.8634 17.8897 20.4953 17.9278 21.2367C18.0348 17.5608 16.8957 11.69 13.7483 9.012C16.2936 9.97912 18.2255 11.5352 19.1135 13.5722C19.3504 11.781 18.577 10.2681 17.7877 8.72404C17.312 7.79358 16.8306 6.85181 16.561 5.83099C18.8858 7.15802 21.6687 7.43138 24.2001 6.7302C21.9135 6.96439 20.7974 5.94575 19.9591 4.35547H218.11C217.18 4.77406 216.262 5.24556 215.341 5.71856C212.673 7.08942 209.98 8.47284 206.902 8.6172C205.717 8.66857 204.73 8.55976 203.767 8.17509C208.376 10.2988 216.467 12.7324 221.619 11.9208C218.974 13.244 215.923 13.7909 212.842 13.3068C214.985 14.4767 217.337 14.753 219.737 15.0349C221.184 15.2048 222.648 15.3767 224.094 15.7476C221.115 16.7093 219.22 18.5922 218.702 20.8335C220.098 18.2519 223.422 18.8564 227.593 19.6147C228.678 19.812 229.82 20.0197 231 20.1844V46.2216C229.579 46.1801 228.112 46.088 226.595 45.872C224.678 45.6031 221.972 44.932 220.76 43.7368C222.373 46.2491 224.435 48.2471 227.531 49.552C225.448 48.7399 222.966 48.3772 220.467 48.012C217.037 47.5108 213.576 47.0049 211.072 45.326C210.111 44.6761 209.465 44.0185 209.115 43.1637C210.503 47.4718 214.245 54.0417 219.014 56.4161C215.651 55.8923 212.76 54.537 210.887 52.3741C211.348 54.517 212.872 56.0965 214.426 57.7084C215.363 58.6798 216.312 59.6629 217.046 60.7884C213.791 59.793 210.437 60.1337 207.776 61.5502C210.94 60.5466 212.816 62.1801 214.825 64.5703H20.8429C18.8728 63.9276 16.6258 63.8919 14.442 64.5703H14.3803C14.9833 63.6183 15.7658 62.7822 16.5389 61.956C17.8328 60.5734 19.1006 59.2186 19.4573 57.3954C17.9026 59.2486 15.4705 60.4258 12.6241 60.9015C16.6337 58.842 19.7047 53.2307 20.8132 49.5612C20.5304 50.2899 19.992 50.8541 19.1873 51.4146C17.0886 52.8629 14.1587 53.3243 11.2555 53.7815C9.14048 54.1146 7.03962 54.4454 5.28448 55.154C7.89138 54.0178 9.60967 52.3028 10.9386 50.1553C9.92911 51.181 7.64256 51.7757 6.02002 52.0217C5.33532 52.127 4.66205 52.2022 4 52.2568V15.9809ZM19.4505 57.3882L19.4467 57.3986C19.4467 57.3986 19.4556 57.3946 19.4574 57.3894L19.4505 57.3882ZM212.836 13.2971L212.849 13.3027C212.849 13.3027 212.839 13.3048 212.832 13.302L212.836 13.2971ZM210.895 52.3661L210.9 52.3785C210.9 52.3785 210.889 52.3739 210.887 52.3676L210.895 52.3661ZM19.1035 13.5763L19.1033 13.5654C19.1033 13.5654 19.1106 13.5709 19.1107 13.5764L19.1035 13.5763Z"
            fill="#363636"
          />
        </g>
        <foreignObject x="0" y="0" width="100%" height="100%">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            className="flex items-center justify-center"
            style={{
              textAlign: 'center',
              color: '#fff',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="19"
              viewBox="0 0 22 19"
              fill="none"
            >
              <path
                d="M1.33105 14.7002H17.4082C17.5524 14.7002 17.6918 14.65 17.8023 14.5584C17.9567 14.4297 21.4792 11.4128 21.694 4.90039H4.42746C4.2135 10.8119 0.96944 13.5904 0.935727 13.6182C0.738084 13.7844 0.665368 14.056 0.754285 14.2977C0.842586 14.5387 1.07271 14.7002 1.33105 14.7002Z"
                fill="#F0ED9C"
              />
              <path
                d="M21.0996 1.22497H18.0236V0.612487C18.0236 0.269494 17.7529 0 17.4084 0C17.0639 0 16.7932 0.269494 16.7932 0.612487V1.22497H13.6762V0.612487C13.6762 0.269494 13.4055 0 13.061 0C12.7165 0 12.4458 0.269494 12.4458 0.612487V1.22497H9.36982V0.612487C9.36982 0.269494 9.09914 0 8.75462 0C8.41011 0 8.13943 0.269494 8.13943 0.612487V1.22497H5.06344C4.71893 1.22497 4.44824 1.49447 4.44824 1.83746V3.67492H21.7148V1.83746C21.7148 1.49447 21.4441 1.22497 21.0996 1.22497Z"
                fill="#F0ED9C"
              />
              <path
                d="M18.5925 15.4972C18.2585 15.7741 17.8392 15.9248 17.4084 15.9248H4.44824V17.7623C4.44824 18.1008 4.7234 18.3748 5.06344 18.3748H21.0996C21.4396 18.3748 21.7148 18.1008 21.7148 17.7623V10.8965C20.5287 13.7936 18.8736 15.263 18.5925 15.4972Z"
                fill="#F0ED9C"
              />
            </svg>
            <p style={{ margin: '0 10px', color: '#F0ED9C' }}>
              מתכנן לצפות
            </p>
          </div>
        </foreignObject>
        <defs>
          <filter
            id="filter0_d_1664_7988"
            x="0.3"
            y="0.655469"
            width="234.4"
            height="67.6148"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.85" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1664_7988"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1664_7988"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
}